export default __webpack_public_path__ + "static/media/Levitate D8.4 Policy Recommendations.a1a79c1d.pdf";